import { globalGetService } from '@/utils/globalApiServices';

export const getBrandCount = async (data = {}) => {
  const response = await globalGetService(
    'csp/statistics/brand?excludeSoleProprietor=true',
    data
  );
  return response?.ok ? (response.data.total as number) : 0;
};
